import { ATMobilityBenefitDetailsDTO, ATMobilityBenefitDetailsDTORefundTypeEnum, BenefitDTO } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class ATMobilityBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsATMobility = activeBenefit.details as ATMobilityBenefitDetailsDTO;

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.name`,
      navigateTo: '/at_mobility',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey:
        detailsATMobility.refundType === ATMobilityBenefitDetailsDTORefundTypeEnum.Yearly
          ? `benefitModule:benefit.${activeBenefit.benefit}.descriptionYearly`
          : `benefitModule:benefit.${activeBenefit.benefit}.description`,
      descriptionValues: {
        refund: detailsATMobility.refund,
        maxRefund: detailsATMobility.maxRefund,
      },
      benefitProgress:
        detailsATMobility.maxRefund > 0 ? Math.min(100, Math.max(0, (detailsATMobility.refund / detailsATMobility.maxRefund) * 100)) : 0,
    };
  }
}
